import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { TabNavigation, Checkbox, NextStepButton, Logo } from "components";
import { TAB_4A_TOGGLE_YEAR, MOVE_TAB } from "actions";

function findYear(year, years) {
  let selected = false;
  years.forEach(y => {
    if (y.value === year) {
      selected = true;
      return;
    }
  });
  return selected;
}

const CheckBoxContainer = styled.div`
  label {
    color: ${props => props.bg};
  }
  input[type="checkbox"]:checked + label {
    border-color: ${props => props.bg};
  }
`;

const Tab4A = props => {
  const { years, yearsNotSure, toggleYear, moveToNextTab, domain } = props;
  return (
    <div className="form_steps">
      <div className="form_steps--inner flex">
        <div className="full_column">
          <Logo />
          <TabNavigation />
          <div>
            <h2 className="checkbox_container--title">{domain.Strings.tab4ATitle}</h2>
            <div className="checkbox_container--content">
              <p>{domain.Strings.tab4ASubTitle}</p>
            </div>
            <CheckBoxContainer bg={domain.BaseColour} className="checkbox_container">
              <Checkbox checked={findYear("2020", years)} onChange={toggleYear} data={{ label: "2020-2021" }} name="2020" id="2020" />
              <label htmlFor="2020">2020/21</label>
              <Checkbox checked={findYear("2019", years)} onChange={toggleYear} data={{ label: "2019-2020" }} name="2019" id="2019" />
              <label htmlFor="2019">2019/20</label>
              <Checkbox checked={findYear("2018", years)} onChange={toggleYear} data={{ label: "2018-2019" }} name="2018" id="2018" />
              <label htmlFor="2018">2018/19</label>
              <Checkbox checked={findYear("2017", years)} onChange={toggleYear} data={{ label: "2017-2018" }} name="2017" id="2017" />
              <label htmlFor="2017">2017/18</label>
              <Checkbox checked={yearsNotSure} onChange={toggleYear} data={{ label: "" }} name="not_sure" id="not_sure" />
              <label htmlFor="not_sure">{domain.Strings.tab4ANotSure}</label>
            </CheckBoxContainer>
            <NextStepButton text={domain.Strings.tab4ANextBtn} onClick={moveToNextTab} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleYear: ({ name, checked, data }) => dispatch({ type: TAB_4A_TOGGLE_YEAR, name, checked, label: data.label }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab4A);
